import { SelectedTransaction } from "@components/transactions/TransactionsBulkActions/transactionsBulkActionsContext";
import { pluralize } from "@common/helpers/string";
import { TransactionPreview } from "@components/transactions/TransactionPreview/TransactionPreview";
import { useMemo, useState } from "react";
import { Button } from "@design-system/Button/Button";
import styles from "./TaskAttachment.module.scss";

interface Props {
    transactionsTask?: {
        transactions?: SelectedTransaction[];
        transactionsCount?: number;
    };
}

const MAX_PREVIEW_ITEMS = 3;

export const TaskAttachment = ({ transactionsTask }: Props) => {
    const [showAllTransactions, setShowAllTransactions] = useState(false);

    const numberOfTransactionsToShow = useMemo(
        () =>
            showAllTransactions
                ? transactionsTask?.transactions?.length
                : MAX_PREVIEW_ITEMS,
        [showAllTransactions, transactionsTask?.transactions],
    );

    if (!transactionsTask) {
        return null;
    }

    const numberOfTransactions = transactionsTask.transactions?.length ?? 0;

    if (numberOfTransactions) {
        return (
            <div className={styles.taskAttachmentContainer}>
                <div className={styles.title}>
                    {numberOfTransactions}{" "}
                    {pluralize("transaction", numberOfTransactions)} associated
                </div>
                <div className={styles.transactionPreviewContainer}>
                    {transactionsTask.transactions
                        ?.slice(
                            0,
                            numberOfTransactionsToShow ?? numberOfTransactions,
                        )
                        .map((transaction) => (
                            <TransactionPreview
                                className={styles.transactionPreview}
                                key={transaction.id}
                                transaction={transaction}
                            />
                        ))}
                    {numberOfTransactions > MAX_PREVIEW_ITEMS &&
                    !showAllTransactions ? (
                        <Button
                            variant="link"
                            size="sm"
                            type="button"
                            block={false}
                            onClick={() => setShowAllTransactions(true)}
                        >
                            +{numberOfTransactions - MAX_PREVIEW_ITEMS} more
                        </Button>
                    ) : null}
                </div>
            </div>
        );
    }

    return (
        <div className={styles.taskAttachmentContainer}>
            <div className={styles.title}>
                {transactionsTask.transactionsCount}{" "}
                {pluralize(
                    "transaction",
                    transactionsTask.transactionsCount ?? 0,
                )}{" "}
                attached based on the applied filters
            </div>
        </div>
    );
};
